import { render, staticRenderFns } from "./InvoicesAddressed.vue?vue&type=template&id=a78901a2&"
import script from "./InvoicesAddressed.vue?vue&type=script&lang=js&"
export * from "./InvoicesAddressed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports